export class QuotationHistoryModel {
	description: string;
	id: string;
	partCode: string;
	partId: string;

	constructor(model: any) {
		this.description = model.description;
		this.id = model.id;
		this.partCode = model.part_code;
		this.partId = model.part_id;
		}
}
